<template>
<!-- 车补记录 -->
  <div class="content_main">
    <div class="content_main_top">
      <a-button type="primary" @click="exp"> 数据导出</a-button>
    </div>
    <div class="content_main_top">
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.subsidyCode"
        allowClear
        placeholder="审批编号"
        @keyup.enter.native="serch_get_lis"
      />
      <a-select
        placeholder="审批状态"
        allowClear
        class="a_input_self margin_self"
        v-model="serchInfo.status"
        default-value="0"
        @keyup.enter.native="serch_get_lis"
      >
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option v-for="(val, key) in status_apply" :key="key" :value="key">{{ val.txt }}</a-select-option>
      </a-select>
      <a-select
        placeholder="审批结果"
        allowClear
        class="a_input_self margin_self"
        v-model="serchInfo.result"
        default-value="0"
        @keyup.enter.native="serch_get_lis"
      >
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option v-for="(val, key) in result_apply" :key="key" :value="key">{{ val.txt }}</a-select-option>
      </a-select>
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.createByName"
        allowClear
        placeholder="发起人姓名"
        @keyup.enter.native="serch_get_lis"
      />
      <a-select
        show-search
        allowClear
        placeholder="所属公司"
        class="margin_self"
        @change="handlecompany"
        v-model="serchInfo.companyId"
        @keyup.enter.native="serch_get_lis"
        style="width: 120px"
      >
        <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select>
      <a-tree-select
        allowClear
        :treeData="deptTree"
        v-model="serchInfo.deptId"
        :disabled="!serchInfo.companyId"
        placeholder="所属部门"
        @keyup.enter.native="serch_get_lis"
        class="margin_self"
        style="width: 170px"
        treeDefaultExpandAll
      >
      </a-tree-select>
      <!-- <a-select show-search allowClear v-model="serchInfo.deptId" :disabled="!serchInfo.companyId" placeholder="所属部门"
			 @keyup.enter.native="serch_get_lis" class="margin_self" style="width: 170px">
				<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
					{{ item.dept_name }}
				</a-select-option>
			</a-select> -->
      <a-range-picker
        valueFormat="YYYY-MM-DD"
        style="margin-right: 10px; width: 220px"
        allowClear
        :value="dates"
        @change="onChange"
        :placeholder="['用车时间', '用车时间']"
        @keyup.enter.native="serch_get_lis"
      />
      <a-button type="primary" @click="serch_get_lis"> 查询 </a-button>
      <a-button type="primary" ghost @click="result"> 重置 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        :data-source="lis"
        bordered
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :scroll="{ x: 3000, y: scroll_y, scrollToFirstRowOnChange: true }"
      >
        <a-table-column key="index" title="序号" data-index="index" width="70px">
          <template scope="text, record, index">{{
            (pagination.current - 1) * pagination.pageSize + index + 1
          }}</template>
        </a-table-column>
        <a-table-column key="subsidyCode" title="审批编号" ellipsis="true" data-index="subsidyCode" />
        <a-table-column key="title" title="标题" ellipsis="true" data-index="title" />
        <a-table-column key="result" title="审批状态" ellipsis="true" data-index="result">
          <template scope="text,record">
            <span class="tag_class" :style="{ background: result_apply[record.result].color }">
              {{ result_apply[record.result].txt }}
            </span>
          </template>
        </a-table-column>
        <a-table-column key="status" title="审批结果" ellipsis="true" data-index="status">
          <template scope="text,record">
            <span class="tag_class" :style="{ background: status_apply[record.status].color }">
              {{ status_apply[record.status].txt }}
            </span>
          </template>
        </a-table-column>
        <a-table-column key="createTime" title="发起时间" ellipsis="true" data-index="createTime" />
        <a-table-column key="endTime" title="完成时间" ellipsis="true" data-index="endTime" />
        <a-table-column key="createByName" title="发起人姓名" ellipsis="true" data-index="createByName" width="120px" />
        <a-table-column key="deptName" title="发起人部门" ellipsis="true" data-index="deptName" width="120px" />
        <a-table-column key="relationCode" title="关联审批单" ellipsis="true" data-index="relationCode" width="120px" />
        <a-table-column key="companyUseName" title="所属公司" ellipsis="true" data-index="companyUseName" />
        <a-table-column key="deptUseName" title="所属部门" ellipsis="true" data-index="deptUseName" />
        <a-table-column key="carTypes" title="车辆属性" ellipsis="true" data-index="carTypes">
          <template scope="text,record">
            {{ carMap2[record.carTypes] }}
          </template>
        </a-table-column>
        <a-table-column key="plateNumber" title="牌照号" ellipsis="true" data-index="plateNumber" />
        <a-table-column key="useCarDate" title="实际用车日期" ellipsis="true" data-index="useCarDate" width="120px" />
        <a-table-column
          key="stillCarDate"
          title="实际还车日期"
          ellipsis="true"
          data-index="stillCarDate"
          width="120px"
        />
        <a-table-column key="goMileage" title="出车前里程(公里)" ellipsis="true" data-index="goMileage" width="150px" />
        <a-table-column
          key="backMileage"
          title="还车时里程(公里)"
          ellipsis="true"
          data-index="backMileage"
          width="150px"
        />
        <a-table-column
          key="applyMileage"
          title="申请补贴里程数"
          ellipsis="true"
          data-index="applyMileage"
          width="150px"
        />
        <a-table-column key="money" title="本次出行加油金额" ellipsis="true" data-index="money" width="150px" />
        <a-table-column
          key="capitalizeMoney"
          title="本次出行加油金额(大写)"
          ellipsis="true"
          data-index="capitalizeMoney"
          width="200px"
        />
        <a-table-column key="remark" title="备注" ellipsis="true" data-index="remark" />
      </a-table>
    </div>
  </div>
</template>
<script>
import { limitCompany } from '@/utils/limitCompany'
import { getDeptListEnable2 } from '@/api/system'
import { biz_car_subsidy_apply } from '@/api/administrative'
import {
  // get_dept_tree,
  // get_dept_tree2,
  get_biz_car_xlsx,
} from '@/api/assetmenag'
export default {
  data() {
    return {
	 companylist: [],
      dates: [],
      changecar: false,
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      labelCol4: {
        span: 6,
      },
      wrapperCol4: {
        span: 18,
      },
      deptTree: [],
      form: {},
      rules: {
        plateNumber: [
          {
            required: true,
            message: '请输入车牌号',
            trigger: 'change',
          },
        ],
        frameNumber: [
          {
            required: true,
            message: '请输入车架号',
            trigger: 'blur',
          },
        ],
        companyId: [
          {
            required: true,
            message: '请选择所属公司',
            trigger: 'change',
          },
        ],
        types: [
          {
            required: true,
            message: '请选择车辆属性',
            trigger: 'change',
          },
        ],
      },
      serchInfo: {
        subsidyCode: '',
        status: undefined,
        result: undefined,
        createByName: '',
        companyId: undefined,
        deptId: undefined,
        createTime1: '',
        createTime2: '',
      },
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 16,
      },
      scroll_y: 150,
      loading: false,
      lis: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      is_details: false,
      formrow: {},
      carvisible: false,
    }
  },
  created() {
	  limitCompany().then((res) => {
      res.forEach((item) => {
        if (item.deptId) {
          this.companylist.push(item)
        }
      })
	  console.log(this.companylist, 'companylist======================')
    })

  },
  mounted() {
    this.get_list()
    
    // get_dept_tree().then((res) => {
    // 	this.companylist = res.data.dept_lis
    // 	this.companylist.unshift({
    // 		dept_id: 0,
    // 		dept_name: '所有公司',
    // 		child_lis: [],
    // 	})
    // })
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 120
      }, 1000)
    })
    // get_dept_tree2().then((res) => {
    //   this.companylist2 = res.data.dept_lis
    // })
  },
  methods: {
    onChange(date, dateString) {
      this.dates = date
      this.serchInfo.createTime1 = date[0]
      this.serchInfo.createTime2 = date[1]
      console.log(this.serchInfo.createTime1, this.serchInfo.createTime2, date, '==========================')
    },
    result() {
      this.serchInfo = {}
      this.dates = []
    },
    //切换公司
	 handlecompany(e) {
      this.serchInfo.deptId = undefined
		for (let i = 0; i < this.companylist.length; i++) {
			if(this.serchInfo.companyId == this.companylist[i].deptId){
				this.deptTree = this.companylist[i].children
			}
		}
    },
    // handlecompany(value) {
    //   this.deptTree = []
    //   this.serchInfo.deptId = undefined
    //   this.$nextTick(() => {
    //     getDeptListEnable2().then((res) => {
    //       const data = res.rows
    //       if (data.length > 0) {
    //         const min = Math.min(...data.map((m) => m.parentId))
    //         this.buildtree2(data, this.deptTree, this.serchInfo.companyId)
    //       }
    //     })
    //   })
    // },
    exp() {
      get_biz_car_xlsx({
        pageNum: 1,
        pageSize: 99999,
        subsidyCode: this.serchInfo.subsidyCode,
        status: this.serchInfo.status,
        result: this.serchInfo.result,
        createByName: this.serchInfo.createByName,
        belongCompanyId: this.serchInfo.companyId,
        belongDeptId: this.serchInfo.deptId,
        excel: 1,
      })
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    //获取列表
    get_list() {
      biz_car_subsidy_apply({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        subsidyCode: this.serchInfo.subsidyCode,
        status: this.serchInfo.status,
        result: this.serchInfo.result,
        createByName: this.serchInfo.createByName,
        belongCompanyId: this.serchInfo.companyId,
        belongDeptId: this.serchInfo.deptId,
        stillCarDate1: this.serchInfo.createTime1,
        stillCarDate2: this.serchInfo.createTime2,
      }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          var lis = res.rows
          this.lis = res.rows
          const pagination = { ...this.pagination }
          pagination.total = res.total
          this.pagination = pagination
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    //重置
    reset() {
      this.serchInfo = {
        purchaseCode: '',
        createBy: '',
        status: undefined,
        buStatus: undefined,
        company_id: undefined,
        deptId: undefined,
        createTimelist: [],
      }
    },
    //搜索
    serch_get_lis() {
      this.loading = true
      this.pagination.current = 1
      this.get_list()
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loading = true
      this.get_list()
    },
  },
}
</script>
<style scoped lang='less'>
.ant-table td {
  white-space: nowrap;
}
</style>
